// import { gsap } from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
const { $ } = window

export default {
	init() {
		aboutCardRotator()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}

function aboutCardRotator() {
	const $aboutCardRotator = $('.acr-cards-wrap.slick')
	if(!$aboutCardRotator.length) {
		return
	}

	$aboutCardRotator.slick({
		arrows: false,
		dots: true,
		fade: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	})

	$aboutCardRotator.find('.slick-slide').on('click', function(){
		$aboutCardRotator.slick('slickNext')
	})
	$aboutCardRotator.on('swipe', function(event, slick, direction){
		// console.log(direction);
		if(direction == 'left') {
			$aboutCardRotator.slick('slickPrev')
		} else {
			$aboutCardRotator.slick('slickNext')
		}
	});
}
